import { Head } from '@inertiajs/react'
import { Header } from '../../components/landing/header'
import { Hero } from '../../components/landing/hero'
import { ProblemSection } from '../../components/landing/problem-section'
import { BenefitsSection } from '../../components/landing/benefits-section'
import { StatsSection } from '../../components/landing/stats-section'
import { HowItWorksSection } from '../../components/landing/how-it-works-section'
import { TestimonialsSection } from '../../components/landing/testimonials-section'
import { PricingSection } from '../../components/landing/pricing-section'
import { FAQSection } from '../../components/landing/faq-section'
import { CTASection } from '../../components/landing/cta-section'
import { Footer } from '../../components/landing/footer'

export default function Landing() {
  return (
    <>
      <Head title="Instagram Auto-Reply Landing" />
      <main className="min-h-screen">
        <Header />
        <Hero />
        <ProblemSection />
        <BenefitsSection />
        <StatsSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <PricingSection />
        <FAQSection />
        <CTASection />
        <Footer />
      </main>
    </>
  )
}
